import { render, staticRenderFns } from "./GLBudgetQuery.vue?vue&type=template&id=835c2cbe&"
import script from "./GLBudgetQuery.vue?vue&type=script&lang=js&"
export * from "./GLBudgetQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports